import { __extends } from "tslib";
import { EventEmitter } from 'events';
/**
 * Types of events fired from this action manager
 *
 * @todo evlave - add other events and payloads for event emitters as needed
 * as well as to optimize updates when actions change.Right now, we're updating all of them
 * since there will be only 4...
 */
export var ActionManagerEventType;
(function (ActionManagerEventType) {
    ActionManagerEventType["ActionsUpdated"] = "actions-updated";
})(ActionManagerEventType || (ActionManagerEventType = {}));
var ActionManagerEventEmitter = /** @class */ (function (_super) {
    __extends(ActionManagerEventEmitter, _super);
    function ActionManagerEventEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionManagerEventEmitter.prototype.on = function (event, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listener) {
        return _super.prototype.on.call(this, event, listener);
    };
    ActionManagerEventEmitter.prototype.once = function (event, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listener) {
        return _super.prototype.once.call(this, event, listener);
    };
    ActionManagerEventEmitter.prototype.emit = function (event) {
        return _super.prototype.emit.call(this, event);
    };
    return ActionManagerEventEmitter;
}(EventEmitter));
export { ActionManagerEventEmitter };
//# sourceMappingURL=actionManager.js.map